export const setQueryStringParameter = (
  key: string,
  value: string | undefined,
) => {
  const params = new URLSearchParams(window.location.search);
  if (value === undefined) {
    params.delete(key);
  } else {
    params.set(key, value);
  }
  window.history.replaceState(
    {},
    '',
    decodeURIComponent(`${window.location.pathname}?${params.toString()}`),
  );
};
